// // // // import axios from "axios";

// // // // const axiosClient = axios.create({
// // // //   baseURL: `${process.env.REACT_APP_BASE_URL}/`,
// // // // });

// // // // axiosClient.interceptors.request.use((config) => {
// // // //   const token = localStorage.getItem("ACCESS_TOKEN");

// // // //   // Check if the URL matches the forgot password endpoint
// // // //   const isForgotPasswordEndpoint = config.url === "/auth/forgot_password/";

// // // //   // Only add the Authorization header if the token exists and the endpoint is not the forgot password endpoint
// // // //   if (token && !isForgotPasswordEndpoint) {
// // // //     config.headers.Authorization = `JWT ${token}`;
// // // //   }

// // // //   return config;
// // // // });

// // // // axiosClient.interceptors.response.use(
// // // //   (response) => {
// // // //     return response;
// // // //   },
// // // //   (error) => {
// // // //     const { response } = error;

// // // //     if (response) {
// // // //       switch (response.status) {
// // // //         case 401:
// // // //           // Handle unauthorized, maybe redirect to login or refresh token
// // // //           localStorage.removeItem("ACCESS_TOKEN");
// // // //           // Notify the user (e.g., using a toast library)
// // // //           window.location.href = "/";
// // // //           break;

// // // //         case 403:
// // // //           alert("You do not have permission to perform this action.");
// // // //           break;

// // // //         case 500:
// // // //           alert("A server error occurred. Please try again later.");
// // // //           break;

// // // //         default:
// // // //           alert("An error occurred. Please try again.");
// // // //       }
// // // //     } else {
// // // //       alert("Network error. Please check your connection.");
// // // //     }

// // // //     throw error;
// // // //   }
// // // // );

// // // // export default axiosClient;

// import axios from "axios";

// const baseURL = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");

// const axiosClient = axios.create({
//   baseURL: `${baseURL}/`,
// });

// axiosClient.interceptors.request.use((config) => {
//   const token = localStorage.getItem("ACCESS_TOKEN");

//   // endpoints that must NOT include JWT token
//   const openEndpoints = [
//     "auth/login/",
//     "dj-rest-auth/login/",
//     "dj-rest-auth/password/reset/",
//   ];

//   const url = (config.url || "").replace(/^\/+/, "");
//   const isOpen = openEndpoints.some((e) => url.startsWith(e));

//   if (token && !isOpen) {
//     // Your backend accepts "JWT <token>" (as you tested)
//     config.headers.Authorization = `JWT ${token}`;
//   }

//   return config;
// });

// axiosClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const { response } = error;

//     if (response) {
//       if (response.status === 401) {
//         localStorage.removeItem("ACCESS_TOKEN");
//         localStorage.removeItem("REFRESH_TOKEN");
//         window.location.href = "/";
//       } else if (response.status === 403) {
//         alert("You do not have permission to perform this action.");
//       } else if (response.status >= 500) {
//         alert("A server error occurred. Please try again later.");
//       }
//     } else {
//       alert("Network error. Please check your connection.");
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosClient;




/////////////////////////////////////////////////////////
// src/axiosClient.js
// import axios from "axios";

// const rawBase = process.env.REACT_APP_BASE_URL || "";
// const baseURL = rawBase.replace(/\/+$/, ""); // remove trailing slash(es)

// const axiosClient = axios.create({
//   baseURL, // IMPORTANT: no trailing slash
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// axiosClient.interceptors.request.use((config) => {
//   const token = localStorage.getItem("ACCESS_TOKEN");

//   // If you really have a public endpoint, add it here.
//   // For now keep it simple:
//   // const publicEndpoints = ["/auth/login/"];
//   // const isPublic = publicEndpoints.includes(config.url);

//   if (token) {
//     config.headers.Authorization = `JWT ${token}`;
//   }

//   return config;
// });

// axiosClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const { response } = error;

//     if (response) {
//       if (response.status === 401) {
//         localStorage.removeItem("ACCESS_TOKEN");
//         localStorage.removeItem("REFRESH_TOKEN");

//         // Avoid redirect loop if already on login
//         if (window.location.pathname !== "/") {
//           window.location.href = "/";
//         }
//       } else if (response.status === 403) {
//         alert("You do not have permission to perform this action.");
//       } else if (response.status >= 500) {
//         alert("Server error. Please try again later.");
//       }
//     } else {
//       alert("Network error. Please check your connection.");
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosClient;

/////////////////////////////

import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL || "/api/";

const axiosClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("ACCESS_TOKEN");

  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response) {
      if (response.status === 401) {
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("REFRESH_TOKEN");

        if (window.location.pathname !== "/") {
          window.location.href = "/";
        }
      } else if (response.status === 403) {
        alert("You do not have permission to perform this action.");
      } else if (response.status >= 500) {
        alert("Server error. Please try again later.");
      }
    } else {
      alert("Network error. Please check your connection.");
    }

    return Promise.reject(error);
  }
);

export default axiosClient;